module.exports = __webpack_public_path__ + "assets/close.84b7fbd6.cur";